<!-- 横线分隔条 组件 -->

<template>
  <div class="common-header">
    <mt-header style="background-color:#E60202;position:fixed;left:0;top:0;z-index:99999;width:100%;height:33px;">
		  <router-link to="/person" slot="left">
		    <mt-button><i class="iconfont ren" style="height:15px;color:white;">&nbsp;{{$store.state.mineStore.userName}}</i></mt-button>
		  </router-link>
		</mt-header>
  </div>
</template>

<script>
import store from "@/store/index";

export default {
  components: {},
  data () {
    return {}
  },
  props: {},
  watch: {},
  methods: {},
  filters: {},
  computed: {},
  created () {},
  mounted () {},
  destroyed () {}
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/common-header.vue